import api from '../api/axios';

const getAll = () => {
  return api.get('/airflow-items');
};

const getById = (id) => {
  return api.get(`/airflow-items/${id}`);
};

const create = (data) => {
  return api.post('/airflow-items', data);
};

const update = (id, data) => {
  return api.patch(`/airflow-items/${id}`, data);
};

const remove = (id) => {
  return api.delete(`/airflow-items/${id}`);
};

const airflowItemsServices = {
  getAll,
  getById,
  create,
  update,
  remove,
};

export default airflowItemsServices;
